import React from "react";
import {Grid, Row, Col} from "react-flexbox-grid";

function SocialMediaRow(props) {
	return (
		<Grid>
			<Row center="xs">
				<Col>
					<a
						href={props.website}
						rel="noopener noreferrer"
						target="_blank"
					>
						<img
							style={{
								height: props.size,
								marginRight: props.size
							}}
							alt="website"
							src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725716/site_kyabpt.svg"
						/>
					</a>
				</Col>
				{props.twitter && (
					<Col>
						<a
							href={props.twitter}
							rel="noopener noreferrer"
							target="_blank"
						>
							<img
								style={{
									height: props.size,
									marginRight: props.size
								}}
								alt="twitter"
								src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725717/twitter_d0loiw.svg"
							/>
						</a>
					</Col>
				)}
				<Col>
					<a
						href={props.letterboxd}
						rel="noopener noreferrer"
						target="_blank"
					>
						<img
							style={{height: props.size}}
							alt="letterboxd"
							src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725713/letterboxd_dvvo46.svg"
						/>
					</a>
				</Col>
			</Row>
		</Grid>
	);
}

export default SocialMediaRow;
